import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, TransitionGroup as _TransitionGroup, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-00f03c58")

_pushScopeId("data-v-00f03c58")
const _hoisted_1 = { class: "surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden" }
const _hoisted_2 = { class: "flex flex-column align-items-center justify-content-center" }
const _hoisted_3 = { style: {"border-radius":"56px","padding":"0.3rem"} }
const _hoisted_4 = {
  class: "w-full surface-card py-8 px-5 sm:px-8",
  style: {"border-radius":"53px"}
}
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "text-center mb-5" }, [
  /*#__PURE__*/_createVNode("div", { class: "text-900 text-3xl font-medium mb-3" }, "管理者のユーザーIDとパスワードの変更を行います")
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("label", {
  for: "userid",
  class: "block text-900 text-xl font-medium mb-2"
}, "ユーザーID", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("label", {
  for: "test",
  class: "block text-900 text-xl font-medium mb-2"
}, "新しいパスワード", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("input", {
  type: "checkbox",
  id: "newPassword"
}, null, -1)
const _hoisted_9 = { class: "togglePassword" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", {
  for: "newPassword",
  class: "p-menuitem-icon pi pi-fw pi-eye"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("label", {
  for: "newPassword",
  class: "p-menuitem-icon pi pi-fw pi-eye-slash"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("label", {
  for: "test2",
  class: "block text-900 text-xl font-medium mb-2"
}, "確認用パスワード", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("input", {
  type: "checkbox",
  id: "checkPassword"
}, null, -1)
const _hoisted_14 = { class: "togglePassword" }
const _hoisted_15 = /*#__PURE__*/_createVNode("label", {
  for: "checkPassword",
  class: "p-menuitem-icon pi pi-fw pi-eye"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("label", {
  for: "checkPassword",
  class: "p-menuitem-icon pi pi-fw pi-eye-slash"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_zMessage = _resolveComponent("zMessage")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_TransitionGroup, {
            name: "z-message",
            tag: "div"
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mMessage, (msg) => {
                return (_openBlock(), _createBlock(_component_zMessage, {
                  severity: msg.severity,
                  key: msg.id
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(msg.content), 1)
                  ]),
                  _: 2
                }, 1032, ["severity"]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode("div", null, [
            _hoisted_6,
            _createVNode(_component_InputText, {
              modelValue: _ctx.mReset.USERID,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.mReset.USERID = $event)),
              type: "text",
              id: "userid",
              placeholder: "ユーザーID",
              class: "w-full md:w-30rem mb-5",
              inputStyle: "padding:1rem",
              maxlength: "20",
              onInput: _ctx.fncInputHankaku
            }, null, 8, ["modelValue", "onInput"]),
            _hoisted_7,
            _hoisted_8,
            _createVNode("div", _hoisted_9, [
              _createVNode(_component_InputText, {
                modelValue: _ctx.mReset.PASSWD1,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.mReset.PASSWD1 = $event)),
                type: "password",
                id: "passwd1",
                placeholder: "新しいパスワード",
                class: "hideText w-full md:w-30rem mb-5",
                maxlength: "64",
                inputStyle: "padding:1rem",
                onInput: _ctx.fncInputHankaku
              }, null, 8, ["modelValue", "onInput"]),
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: _ctx.mReset.PASSWD1,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.mReset.PASSWD1 = $event)),
                id: "passwd1",
                placeholder: "新しいパスワード",
                class: "showText w-full md:w-30rem mb-5",
                maxlength: "64",
                inputStyle: "padding:1rem",
                onInput: _ctx.fncInputHankaku
              }, null, 8, ["modelValue", "onInput"]),
              _hoisted_10,
              _hoisted_11
            ]),
            _hoisted_12,
            _hoisted_13,
            _createVNode("div", _hoisted_14, [
              _createVNode(_component_InputText, {
                modelValue: _ctx.mReset.PASSWD2,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.mReset.PASSWD2 = $event)),
                type: "password",
                id: "passwd2",
                placeholder: "確認用パスワード",
                class: "hideText w-full md:w-30rem mb-5",
                inputStyle: "padding:1rem",
                maxlength: "64",
                onInput: _ctx.fncInputHankaku
              }, null, 8, ["modelValue", "onInput"]),
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: _ctx.mReset.PASSWD2,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.mReset.PASSWD2 = $event)),
                id: "passwd2",
                placeholder: "確認用パスワード",
                class: "showText w-full md:w-30rem mb-5",
                inputStyle: "padding:1rem",
                maxlength: "64",
                onInput: _ctx.fncInputHankaku
              }, null, 8, ["modelValue", "onInput"]),
              _hoisted_15,
              _hoisted_16
            ]),
            _createVNode(_component_Button, {
              label: "設定する",
              onClick: _ctx.fncReset,
              class: "w-full p-3 text-xl"
            }, null, 8, ["onClick"])
          ])
        ])
      ])
    ])
  ]))
})